<script>
export default {
    name: "publish-approve-all-button",
    props: {
        elements: Array
    },
    emits: ['approve', 'disapprove'],
    computed: {
        translations() {
            return {
                approve: Lang.langGet("Approve all"),
                disapprove: Lang.langGet("Disapprove all"),
            }
        },
        isAllApproved() {
            if (this.elements.length === 0) {
                return false;
            }

            return !this.elements.some(element => !element.data.approved);
        }
    },
}
</script>

<template>
    <v-btn v-if="isAllApproved" class="btn btn-secondary" @click="$emit('disapprove')">
        <v-icon left>far fa-thumbs-down</v-icon>
        {{ translations.disapprove }}
    </v-btn>
    <v-btn v-else class="btn btn-secondary" @click="$emit('approve')">
        <v-icon left>far fa-thumbs-up</v-icon>
        {{ translations.approve }}
    </v-btn>
</template>

